import React from 'react';

import PropTypes from 'prop-types';

import { CountryItemPanel } from 'apps/auth/components/common/components/CountryItemPanel/CountryItemPanel';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { ComplexPopupRow } from 'apps/auth/components/common/Popup/styles';
import { currencyPropType } from 'apps/auth/helpers/customPropTypes';
import { toLowerCase, toUpperCase } from 'apps/auth/helpers/utils';

const CurrenciesPopup = ({ popupRef = null, ...props }) => {
    const click = (e, currency) => {
        if (props.onCurrencyItemClick) {
            e.preventDefault();
            props.onCurrencyItemClick(e, props.country, currency, props.ccyField);
            popupRef.current.close();
        }
    };

    return (
        <ComplexPopup withoutButton textCenter={props.textCenter} popupRef={popupRef}>
            <>
                {props.title && (
                    <>
                        <ComplexPopupRow>{props.title}</ComplexPopupRow>
                        <Separator />
                    </>
                )}
                {props.currencies.map((currency) => (
                    <CountryItemPanel
                        key={`selectCurrency_${currency.code}`}
                        to={props.getHref(props.country.code, currency.code)}
                        onClick={(e) => click(e, currency)}
                        flagIconName={props.isToFieldsScreen ? toLowerCase(currency.code).substr(0, 2) : toLowerCase(currency.code)}
                        countryName={currency.name}
                        countryCurrency={toUpperCase(currency.code)}
                        isSelectedCountry={Number(props.ccyField?.value) === Number(currency?.id)}
                        getCurrencyIcon={props.getCurrencyIcon}
                        onError={props.onIconRenderError}
                    />
                ))}
            </>
        </ComplexPopup>
    );
};

CurrenciesPopup.propsType = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    currencies: PropTypes.arrayOf(currencyPropType).isRequired,
    isRequest: PropTypes.bool,
    isGlobalFlow: PropTypes.bool,
    textCenter: PropTypes.bool,
    getCurrencyIcon: PropTypes.func,
    onError: PropTypes.func,
    getHref: PropTypes.func,
    title: PropTypes.string,
    country: PropTypes.object,
    ccyField: PropTypes.object,
    isToFieldsScreen: PropTypes.bool,
};

export default CurrenciesPopup;
